import { Link } from "react-router-dom"
import { AlertTriangle } from "lucide-react"
import axios from "axios"
import { useAuth } from "@/components/auth-provider"
import { Button } from "@/components/ui/button"
import { API_BASE } from "@/config/api"
import { toast } from "sonner"

const API = API_BASE

/** Banner when SaaS subscription is past_due / unpaid (payment grace). */
export function PaymentGraceBanner() {
  const { user } = useAuth()
  const status = (user?.subscription_status || user?.subscription?.status || "").toLowerCase()
  const graceEnds = user?.grace_ends_at || user?.subscription?.grace_ends_at
  if (!["past_due", "unpaid"].includes(status)) return null

  const openPortal = async () => {
    try {
      const { data } = await axios.post(`${API}/stripe/billing-portal`)
      if (data.url) window.location.href = data.url
      else toast.info("Portal Stripe neconfigurat")
    } catch {
      toast.error("Portal indisponibil")
    }
  }

  return (
    <div className="border-b border-destructive/30 bg-destructive/10 px-4 py-2.5">
      <div className="mx-auto max-w-6xl flex flex-wrap items-center gap-3 text-sm">
        <AlertTriangle className="h-4 w-4 text-destructive shrink-0" strokeWidth={1.5} />
        <p className="flex-1 text-foreground">
          Plata abonamentului a eșuat
          {graceEnds ? ` — grație până la ${String(graceEnds).slice(0, 10)}` : ""}.
          Actualizează metoda de plată pentru a păstra planul.
        </p>
        <div className="flex gap-2">
          <Button size="sm" className="rounded-full h-8" onClick={openPortal}>
            Actualizează plata
          </Button>
          <Button size="sm" variant="outline" className="rounded-full h-8" asChild>
            <Link to="/app/settings?tab=billing">Setări</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
